<ng-container *ngIf="attachment && attachment.id">
  <td style="width: 0; white-space: nowrap">
    <div>{{ attachment?.folder?.name ?? '' }}</div>
    <button (dragend)="dragendEmitter.emit()" (dragstart)="dragstartEmitter.emit({event: $event, item: attachment})"
            [draggable]="attachment?.id" class="btn btn-hover-primary">
      <sb-icon icon="drag"></sb-icon>
    </button>
  </td>
  <td (mouseenter)="hover = true" (mouseleave)="hover = false">
    <ng-container *ngIf="attachment.displayType === 'LINK' && attachment.attachmentType ===  'LINK'">
      <a [href]="attachment.link" class="d-flex align-items-center" target="_blank">
        <app-file-dummy [draggedObj]="attachment" [dummySize]="'XS'" [hover]="hover" class="mr-3"></app-file-dummy>
        <div>
          <h5 [innerHTML]="attachment.name | truncate : 30" class="font-weight-bold m-0">
          </h5>
          <p><span [innerHTML]="attachment.link |truncate: 90"></span></p>
          <p class="m-0"><span [innerHTML]="attachment.description |truncate: 90"></span></p>
        </div>
      </a>
    </ng-container>
    <ng-container *ngIf="attachment.displayType === 'LINK' && attachment.attachmentType ===  'UPLOAD'">
      <a [download]="attachment.fileName" [href]="attachment.fileLink" class="d-flex align-items-center"
         target="_blank">
        <app-file-dummy [draggedObj]="attachment" [dummySize]="'XS'" [hover]="hover" class="mr-3"></app-file-dummy>
        <div>
          <h5 [innerHTML]="attachment.name | truncate : 30" class="font-weight-bold m-0">
          </h5>
          <p class="m-0">{{ attachment.description }}</p>
        </div>
      </a>
    </ng-container>
    <ng-container *ngIf="attachment.displayType === 'EMBED' || attachment.displayType ===  'IFRAME'">
      <div (click)="openModal.attachmentShowPreview(attachment)" class="d-flex align-items-center">
        <app-file-dummy [draggedObj]="attachment" [dummySize]="'XS'" [hover]="hover" class="mr-3"></app-file-dummy>
        <div>
          <h5 [innerHTML]="attachment.name | truncate : 30" class="font-weight-bold m-0">
          </h5>
          <p class="m-0"><span [innerHTML]="attachment.description |truncate: 90"></span></p>
        </div>
      </div>
    </ng-container>
  </td>
  <td class="d-xxl-table-cell d-none">
    <sb-comp-display-created [data]="attachment"></sb-comp-display-created>
  </td>
  <td>
    <div class="d-flex justify-content-end">
      <ng-container *ngIf="attachment.displayType === 'LINK' && attachment.attachmentType ===  'LINK'">
        <a [href]="attachment.link" class="btn btn-primary mr-1" target="_blank">
          <sb-icon icon="link"></sb-icon>
        </a>
      </ng-container>
      <ng-container *ngIf="attachment.displayType === 'LINK' && attachment.attachmentType ===  'UPLOAD'">
        <a [download]="attachment.fileName" [href]="attachment.fileLink" class="btn btn-primary mr-1"
           target="_blank">
          <sb-icon icon="download"></sb-icon>
        </a>
      </ng-container>
      <ng-container *ngIf="attachment.displayType === 'EMBED' || attachment.displayType ===  'IFRAME'">
        <button (click)="openModal.attachmentShowPreview(attachment)" class="btn btn-primary mr-1">
          <sb-icon icon="preview"></sb-icon>
        </button>
      </ng-container>

      <button (click)="attachmentSelected.emit(attachment);" class="btn btn-primary ml-1 mr-1">
        <sb-icon icon="details"></sb-icon>
      </button>
      <button (click)="openModal.attachmentLinkAttachmentToEntries(attachment)" class="btn btn-secondary ml-1">
        <sb-icon icon="attachmentLink"></sb-icon>
      </button>
    </div>
  </td>
</ng-container>

<ng-container *ngIf="attachment && !attachment.id">
  <td colspan="100">
    <div class="d-flex align-items-center" style="font-size: 4rem;">
      <div class="mr-3" style="width: 80px;">
        <sb-icon [animationOptions]="animationOptions" [dualColor]="true" icon="uploadAltAnimation"></sb-icon>
      </div>
      <h5 class="font-weight-bold m-0">
        {{ 'lang.globals.uploadFiles' | translate }}...
      </h5>
    </div>
  </td>
  <td colspan="100">
    <div class="d-flex align-items-center" style="font-size: 4rem;">
      <div class="mr-3" style="width: 80px;">
        <sb-icon [animationOptions]="animationOptions" [dualColor]="true" icon="linkAnimation"></sb-icon>
      </div>
      <h5 class="font-weight-bold m-0">
        {{ 'lang.globals.processing' | translate }}...
      </h5>
    </div>
  </td>
</ng-container>
